<template>
  <div class="page signup">
    <!-- 회원가입 진입 -->
    <SignUpEntry
      v-if="step === 'entry'"
      @clickPhoneSignUp="step = 'agree'"
      @kakaoSignUp="kakaoSignUp"
      @kakaoSignIn="kakaoSignIn"
    />

    <!-- 약관동의 -->
    <SignUpAgree
      v-if="step === 'agree'"
      :userData="userData"
      @clickBack="confirmBack"
      @clickNext="step = 'sms'"
      @clickCancel="confirmBack"
    />

    <!-- SMS 인증 -->
    <SendSMS
      v-if="step === 'sms'"
      :userData="userData"
      @clickBack="step = 'agree'"
      @clickNextEmit="step = 'profile'"
      @duplicated="step = 'duplicated'"
    />

    <!-- 프로필 입력 -->
    <SignUpUserForm
      v-if="step === 'profile'"
      ref="refSignUpProfile"
      :userData="userData"
      @clickBack="step = 'agree'"
      @clickCancel="step = 'agree'"
      @prepareSignUp="onClickSignUp"
    />

    <!-- 회원가입 완료 -->
    <SignUpCompleted
      v-if="step === 'completed'"
      ref="refSignUpCompleted"
      @goToHome="goToHome"
    />

    <!-- 중복된 가입 정보 -->
    <SignUpDuplicated
      v-if="step === 'duplicated'"
      ref="refSignUpDuplicated"
      :userData="userData"
    />

    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import SignUpEntry from "./comp/SignUpEntry.vue";
import SignUpAgree from "./comp/SignUpAgree.vue";
import SendSMS from "./comp/SendSMS.vue";
import SignUpUserForm from "./comp/SignUpUserForm.vue";
import SignUpCompleted from "./comp/SignUpCompleted.vue";
import SignUpDuplicated from "./comp/SignUpDuplicated.vue";
// import ConfirmDialog from "@/components/common/dialog/ConfirmDialog.vue";
const modelService = require("@/utils/dataModel.js");
import ConfirmDialog from "@/_bayer/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    SignUpAgree,
    SignUpEntry,
    SendSMS,
    SignUpUserForm,
    SignUpCompleted,
    SignUpDuplicated,
    ConfirmDialog,
  },
  data() {
    return {
      // step: "agree",
      // step: "completed",
      // step: "duplicated",
      // step: "sms",
      // step: "profile",
      step: "entry",
      pwShow: false,
      userData: modelService.userModel(),
      checkedData: null,
    };
  },
  computed: {
    ...mapGetters(["isDev"]),
    ...mapState(["kakaoAccount"]),
  },
  mounted() {
    // 회원가입 개발시
    if (this.isDev) {
      // this.step = "profile";
      // this.userData = modelService.userSampleModel();
    }
    // kakaoAccount확인
    console.log("kakaoAccount", this.kakaoAccount);
    if (this.kakaoAccount !== null) {
      this.kakaoAccountDataCheck();
    }
  },
  methods: {
    kakaoAccountDataCheck() {
      const $h = this.$helper;
      this.userData.name = this.kakaoAccount.name;
      this.userData.loginId = $h.makePhoneNumber(
        this.kakaoAccount.phone_number
      );
      this.userData.password = "kakaoEmail_" + this.kakaoAccount.email;
      this.userData.cell = $h.makePhoneNumber(this.kakaoAccount.phone_number);
      this.userData.checkSms = true;
      this.userData.checkSms = true;
      this.userData.signupPath = "kakao";
      this.userData.email = this.kakaoAccount.email;
      this.userData.emailId = $h.changeEmailIdDomainType(
        this.kakaoAccount.email,
        "id"
      );
      this.userData.emailDomain = $h.changeEmailIdDomainType(
        this.kakaoAccount.email,
        "domain"
      );
      this.userData.emailDomainType = $h.changeEmailIdDomainType(
        this.kakaoAccount.email,
        "type"
      );
      this.userData.agreePolicy = true;
      this.userData.agreeTerms = true;
      this.userData.checkAge = true;
      this.userData.marketing = this.kakaoAccount.smsMarketingAgree; // sms마켓팅 카카오에서 가져와야 할 동의
      // this.userData.emailMarketing = true; // email마켓팅 카카오에서 가져와야 할 동의
      // this.step = "agree";
      console.log("userData", this.userData);

      this.step = "profile";
    },
    kakaoSignIn(e) {
      console.log("SignUp page kakaoSignIn", e);
      this.loginAction(e);
    },
    kakaoSignUp(kakaoAccount) {
      console.log("kakaoSignUp kakaoAccount", kakaoAccount);
      this.kakaoAccountDataCheck();
    },
    goToHome() {
      this.$router.push({ path: "/home" }).catch(() => {});
    },
    onClickSignUp() {
      this.saveDataPreLoginQuery(this.userData).then((res) => {
        console.log("res", res);
        if (res === undefined) return;
        this.$helper.showTostMessage("", "회원가입되었습니다.", "success");
        this.step = "completed";
      });
    },
    loginAction(e) {
      e.userAgent = navigator.userAgent.toLowerCase();
      this.signIn(e).then((res) => {
        if (res === undefined) return;
        // 리로드
        window.location.href = "/";
      });
    },
    confirmBack() {
      this.$refs.refConfirmDialog.open("정말 뒤로 가시겠습니까?");
    },
    clickPopupConfirm() {
      this.clearKakaoAccount();
      // this.step = "entry";
      window.location.href = "/";
    },
    ...mapActions(["signIn", "saveDataPreLoginQuery", "clearKakaoAccount"]),
  },
};
</script>

<style lang="scss">
.signup {
  .bottom-btn {
    margin-top: 40px;
  }

  p.step-sub-title {
    text-align: center;
    margin-bottom: 40px;
  }
}
</style>